'use client'

import { Dialog, Button } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  show: boolean
  onConfirm: () => void
  onCancel: () => void
}

const DeleteMessageModal = ({ show, onCancel, onConfirm }: Props) => {
  const translate = useTranslate('conversation.delete_message.modal')

  return (
    <Dialog
      show={show}
      title={translate('title')}
      body={translate('body')}
      testId="delete-message-modal"
      actions={[
        {
          text: translate('actions.delete'),
          theme: 'warning',
          style: Button.Styling.Filled,
          callback: onConfirm,
          testId: 'delete-confirm-button',
        },
        {
          text: translate('actions.cancel'),
          style: Button.Styling.Flat,
          callback: onCancel,
          theme: 'amplified',
        },
      ]}
    />
  )
}

export default DeleteMessageModal
